module.exports = __webpack_public_path__ + "img/rightclound.bd3eaf6f.png";